import { Box, Typography, Link, Button, Divider } from '@mui/material'
import React from 'react'

import { career1, career2, career3, career4 } from '../../../assets/images/Career';
import { SectionTitle } from '../../../components';

const CareerOpportunities = () => {

    const opportunities = [
        {
            name:'internship', 
            image: career1
        },
        {
            name:'experienced',
            image:career2
        },
        {
            name:'craft',
            image:career3
        },
        {
            name:'facility Services',
            image:career4
        }
    ]

  return (
    <Box>
        <SectionTitle 
            firstTitleWord='Opportunities'
            secondTitleWord='At Pangu'
            textStyle={{
                textTransform:'uppercase',
                fontWeight:'1000'
            }}
            sx={{
                '@media screen and (max-width: 762px)':{
                    paddingY:'2rem'
                }
            }}
        />
        <Box
            sx={{
                display:'flex',
                flexDirection:'row',
                justifyContent:'space-evenly',
                flexWrap:'wrap'
            }}
        >
            {opportunities.map((item, index) => (
                <>
                <Box
                    sx={{
                        display:'flex',
                        flexDirection:'column',
                        width:'20%',
                        alignItems:'center',
                        '@media screen and (max-width: 762px)':{
                            width:'100%'
                        }
                    }}
                >
                    <Typography
                        variant='h1'
                        sx={{
                            fontFamily:'var(--title-font)',
                            fontSize:'1.5rem',
                            textTransform:'capitalize',
                            transition: 'transform 0.5s ease-in-out',
                            cursor:'pointer',
                            color:'#000',
                            fontWeight:'500',
                            '&:hover':{
                                transform:'scale(1.3)',
                                color:'blue',
                            }

                        }}
                    >
                        <Link
                            href='/career/offers'
                            sx={{
                                color:'inherit',
                                textDecoration:'none'
                            }}
                        >{item.name}</Link></Typography>

                    <Box 
                        component='img'
                        src={item.image}
                        sx={{
                            objectFit:'contain',
                            width:'100%',
                            marginTop:'2rem'
                        }}
                    />

                    <Button
                        variant='outlined'
                        href='/career/offers'
                        sx={{
                            marginY:'2rem',
                            color:'#000',
                            borderColor:'#000',
                            '&:hover':{
                                backgroundColor:'var(--color-secondary)',
                                color:'#fefefe'
                            }
                        }}
                    >Learn More</Button>
                </Box>
                {index < opportunities.length - 1 && (
                    <Divider
                    sx={{
                        width: '100%', // Make the divider span the full width
                        marginY: '1rem', // Add vertical spacing
                        display:'none',
                        '@media screen and (max-width:762px)':{
                            display:'block'
                        }
                    }}
                    />
                )}
                </>
            ))}
        </Box>
    </Box>
  )
}

export default CareerOpportunities